module.exports = __webpack_public_path__ + "h5/img/4-002.034b0f3c.png";